import { Checkbox, Fieldset } from '@postenbring/hedwig-react'

export default ({ label, name, options, onChange, errorMessage }) => {
    if (!options || !Array.isArray(options)) {
        console.error('CheckboxGroup: options is not an array', options)
        return null
    }
    return (    
        <Fieldset legend={label} errorMessage={errorMessage}>
            {options.map((option, index) => (
                <Checkbox
                    value={option.value}
                    key={index}
                    name={name}
                    onChange={onChange}
                >
                    {option.text}
                </Checkbox>
            ))}

        </Fieldset>
    )
}
